import React, { useMemo } from 'react';

import InfluentialPerson from './InfluentialPerson';
import { ALL_CATEGORY, InfluentialsProps } from './interface';

const Influentials = ({ projectData, searchQuery, selectedCategory }: InfluentialsProps) => {
  const people = useMemo(() => {
    const query = searchQuery.trim().toLowerCase();

    return (projectData || []).filter((person) => {
      if (!person?.name) return false;

      const matchesCategory =
        selectedCategory === ALL_CATEGORY || person.category?.trim() === selectedCategory;
      if (!matchesCategory) return false;

      if (!query) return true;

      return [person.name, person.title, person.company].some(
        (value) => value?.toLowerCase().includes(query)
      );
    });
  }, [projectData, searchQuery, selectedCategory]);

  if (people.length === 0) return null;

  return (
    <div className="min-w-0 md:mt-48">
      {people.map((person, index) => (
        <InfluentialPerson key={`${person.name}-${index}`} person={person} />
      ))}
    </div>
  );
};

export default Influentials;
